export type LoadingState = 'IDLE' | 'ERROR' | 'LOADING' | 'SUCCESS'

export enum LoadingStateEnum {
  IDLE = 'IDLE',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
}
